// app.ts
import App from "next/app";
import {setup} from "twind";
function withTwindApp(configOrBase, BaseApp) {
  if (typeof configOrBase == "function") {
    BaseApp = configOrBase;
    configOrBase = {};
  }
  if (typeof window !== "undefined") {
    setup(configOrBase);
  }
  return BaseApp || App;
}
export {
  withTwindApp as default
};
//# sourceMappingURL=app.js.map
